window.inflComp = window.inflComp || {};

require('./shared/polyfill');

inflComp.React          = require('react');
inflComp.ReactDOM       = require('react-dom');
inflComp.InflunetPromotion = require('advocate/components/influnet_promotion');

module.exports = inflComp;



// WEBPACK FOOTER //
// ./src/exports-logged-out.js